/**
 * @file コンポーネント：フル動画ページスレッドポップアップ スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル
export const StyledPopupContainer = styled.div``;

export const StyledPopupContent = styled.div`
    position: relative;
    height: 100%;
`;

export const StyledPopupThreadListContainer = styled.div`
    display: none;
    height: 100%;

    &.is-show {
        display: block;
    }
`;
